import { useQuery } from '@apollo/client/react'

import { IRI } from '@/components/molecules/Form/Pooling/Material/types'
import { Avatar, AvatarProps } from '@/components/ui/avatar'
import { UserImageDocument } from '@/graphql/api/generated'

export const UserAvatar = ({
  userId,
  ...avatarProps
}: { userId: IRI<'users', string> } & AvatarProps) => {
  const { data } = useQuery(UserImageDocument, {
    variables: {
      id: userId,
    },
  })

  return (
    (data?.user && (
      <Avatar
        src={data.user.avatar?.contentUrl}
        title={`${data.user.firstname} ${data.user.lastname}`}
        {...avatarProps}
      />
    )) || <Avatar />
  )
}
